/** Präfix der Drag-IDs von Katalog-Kacheln — Kachel und Drop-Handler lesen dieselbe Fassung. */
const CATALOG_CARD_PREFIX = 'catalog-card-';

/** Drag-ID einer Katalog-Kachel aus ihrer Scryfall-ID. */
export function catalogCardDragId(scryfallId) {
  return `${CATALOG_CARD_PREFIX}${scryfallId}`;
}

/** Scryfall-ID einer gezogenen Katalog-Kachel, sonst null. */
export function parseCatalogCardId(activeId) {
  if (typeof activeId !== 'string') return null;
  if (!activeId.startsWith(CATALOG_CARD_PREFIX)) return null;
  return activeId.slice(CATALOG_CARD_PREFIX.length);
}

export function parseDraggedCardId(activeId) {
  if (typeof activeId !== 'string') return null;
  if (!activeId.startsWith('card-')) return null;
  return activeId.slice(5);
}

export function isCategoryDragId(id) {
  return typeof id === 'string' && id.startsWith('cat-');
}

export function isCategoryReorderDrag(activeId, overId) {
  return isCategoryDragId(activeId) && isCategoryDragId(overId);
}

export function getOverCategory(over) {
  return over?.data?.current?.category || null;
}

export function getOverCategoryId(over) {
  const id = over?.data?.current?.categoryId;
  return typeof id === 'number' ? id : null;
}

export function isCommanderDrop(over) {
  return over?.data?.current?.commander === true;
}

/**
 * Liefert das Drop-Ziel als { commander: true } | { categoryId, name } | null.
 */
export function resolveTargetCategory(over) {
  if (isCommanderDrop(over)) return { commander: true };
  const categoryId = getOverCategoryId(over);
  const name = getOverCategory(over);
  if (categoryId === null) return null;
  return { categoryId, name };
}
